import { RouteBean } from "./RouteBean";
export class RouteBeanToSave {
    id?:string;
    title?:string;
    kleEmne?:string;
    handlingFacet?:  string;
    channelType?: string;
    systemUUID?:string;
    systemName?:string;
    endPointURI?:string;
    endpointUUID?:string;
    validFrom?: string;
    validTo?: string;
    cvr?: String;
    changedDate?: string;
    changedBy?: String;

    constructor(route: RouteBean) {
        this.id = route.id;
        this.title = route.title;
        this.kleEmne = route.kleEmne;
        this.handlingFacet =  route.handlingFacet;
        this.channelType = route.channelType;
        this.systemUUID = route.systemUUID;
        this.systemName = route.systemName;
        this.endPointURI = route.endPointURI;
        this.endpointUUID = route.endpointUUID;
        this.validFrom = route.validFrom as unknown as string;
        this.validTo = route.validTo  as unknown as string;
        this.cvr = route.cvr;
        this.changedBy = route.changedBy;
        this.changedDate = route.changedDate  as unknown as string;
    }
    }